import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { ProductSearchResultItemGenericLabel } from './ProductSearchResultItemGenericLabel'

type ProductSearchResultItemSellerPromotionLabelProps = { className?: string }

export const ProductSearchResultItemSellerPromotionLabel: FC<
  ProductSearchResultItemSellerPromotionLabelProps
> = ({ className }) => (
  <ProductSearchResultItemGenericLabel
    className={clsx(
      'border-light-primary-strong bg-light-primary-medium',
      className,
    )}
    data-qa-id="serp-has-best-offer-seller-promotion-label"
  >
    <FormattedMessage id="seller.promotion.product.badge" />
  </ProductSearchResultItemGenericLabel>
)
